export default __webpack_public_path__ + "static/media/e-bunifikasi-logotype-l.3d8a7473.svg";